import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import {
  capitalizeFirstLetterAndSpaceSnakeString,
  selectSorterFunction,
} from '../../utils/bills-utils';
import { AutocompleteSelectOption } from '../grid-components/grid-types';
import { HoldReasonFilterProps, StatusFilterLabelText } from './filter-types';

export const holdReasonsSelectOptions = (
  holdVals: string[],
): AutocompleteSelectOption[] =>
  holdVals
    .map(val => ({
      value: val,
      label: capitalizeFirstLetterAndSpaceSnakeString(val),
    }))
    .sort((a, b) => selectSorterFunction(a.label, b.label));

export const HoldReasonFilter = ({
  control,
  errors,
  name = 'holdReasons',
  holdTypes,
  holdTypesError,
  disabled = false,
}: HoldReasonFilterProps): JSX.Element => (
  <Controller
    control={control}
    name={name}
    render={({ field: { onChange, value } }): JSX.Element => (
      <Autocomplete
        multiple
        id="hold-reasons-select"
        value={value}
        options={!holdTypesError ? holdReasonsSelectOptions(holdTypes) : []}
        size="small"
        disabled={disabled}
        isOptionEqualToValue={(option, value): boolean =>
          option.value === value.value
        }
        sx={{ minWidth: 230, maxWidth: 230 }}
        limitTags={1}
        blurOnSelect={true}
        onChange={(_, newValue): void => onChange(newValue)}
        getOptionLabel={(option): string => option.label}
        renderInput={(params): JSX.Element => (
          <HHTextField
            {...params}
            hhVariant="variant-bypass"
            variant="standard"
            label={StatusFilterLabelText.HOLD_REASON}
            error={
              !!holdTypesError ||
              Object.keys(errors?.holdReasons ?? {}).length !== 0
            }
            helperText={
              holdTypesError ||
              Object.keys(errors?.holdReasons ?? {}).length !== 0
                ? ((errors.holdReasons?.message as string) ??
                  'hold reasons unavailable')
                : ''
            }
          />
        )}
      />
    )}
  />
);
